import dashboard from './dashboard/routes';
import home from './home/routes';
import finance from './finance/routes';
import linkbuilder from './linkbuilder/routes';
import settings from './settings/routes';

export default [home, dashboard, finance, linkbuilder, settings];
